export const SPACE_GRID_GAP = 24;
export const SIZES_CONTAINER_XL = 1280;

// 🔬 skip
